import { useState } from 'react';
import MenuComponent from './menu';
import styles from './header.module.scss';
import Avatar from '@mui/material/Avatar';
import { data } from 'configs/menu-config';
import { clearCart } from 'redux/slices/cart';
import { StyledMenu } from 'configs/menuStyle';
import { setSearch } from 'redux/slices/search';
import DebounceSearch from 'components/debounceSearch';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ReactComponent as IconHandbook } from 'assets/icons/icon_handbook.svg';
import { ReactComponent as LogoGlobal } from 'assets/images/logo-global main.svg';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';

const Header = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const { user } = useSelector((state: any) => state.auth, shallowEqual);
  const menuList = data[user?.role];
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);
    dispatch(setSearch({ results: [] }));
  };

  const handleClickAccount = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl2(event.currentTarget);

  return (
    <header className={styles.header}>
      <div className={styles.panels}>
        <div className={styles.logo}>
          <Link to='/' rel='noopener noreferrer' className={styles.linkLogo}>
            <LogoGlobal />
          </Link>
        </div>

        <ul className={styles.navbar}>
          {menuList?.map((item: any, id: number) =>
            item.submenu?.length > 0 ? (
              <Box key={id}>
                <Button
                  disableRipple
                  aria-haspopup='true'
                  onClick={handleClick}
                  id='demo-customized-button'
                  aria-expanded={open ? 'true' : undefined}
                  aria-controls={open ? 'demo-customized-menu' : undefined}
                  className={`${styles.navItemLast} ${open && styles.navItemLastActivee}`}
                  sx={{
                    color: open ? '#005aa9' : '#000000',
                  }}
                  endIcon={open ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}>
                  <IconHandbook className={!open ? styles.icon : styles.iconActive} />
                  {item.name}
                </Button>

                <StyledMenu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                  {item?.submenu?.map((sub: any) => (
                    <NavLink
                      key={sub.id}
                      to={`/${sub.url}`}
                      className={'menuItem'}
                      onClick={handleClose}>
                      {sub.name}
                    </NavLink>
                  ))}
                </StyledMenu>
              </Box>
            ) : (
              <NavLink
                key={item.id + '-' + id}
                to={item.url}
                onClick={() => {
                  dispatch(clearCart());
                  dispatch(setSearch({ results: [] }));
                }}
                className={`${styles.navItem} ${
                  pathname === `/${item.url}` && styles.activeNavItem
                }`}>
                <li>{item.name}</li>
              </NavLink>
            )
          )}
        </ul>
      </div>
      <Box display='flex' alignItems='center'>
        <DebounceSearch />

        <Tooltip title='Настройки аккаунта'>
          <IconButton
            size='small'
            sx={{ ml: 2 }}
            aria-haspopup='true'
            onClick={handleClickAccount}
            aria-controls={open2 ? 'account-menu' : undefined}
            aria-expanded={open2 ? 'true' : undefined}>
            <Avatar sx={{ width: 32, height: 32 }}>
              {user?.username?.slice(0, 1)?.toUpperCase()}
            </Avatar>
          </IconButton>
        </Tooltip>
        <MenuComponent anchorEl2={anchorEl2} open2={open2} close={() => setAnchorEl2(null)} />
      </Box>
    </header>
  );
};

export default Header;
